$(".announcement-bar-section").slick({
  slidesToShow: 1,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  prevArrow: '<div class="slick-arrow prev-arrow"></div>',
  nextArrow: '<div class="slick-arrow next-arrow"></div>',
  autoplaySpeed: 2000,
  arrows: true,
});

$(".hero-slider").slick({
  slidesToShow: 1,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  fade: true,
  autoplaySpeed: 2000,
  arrows: false,
  dots: true,
});

var $ = jQuery.noConflict();
jQuery(document).ready(function ($) {
  if ($(".mobile-slider").length > 0) {
    jQuery(".mobile-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 5000,
          settings: "unslick",
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            adaptiveHeight: false,
          },
        },
      ],
    });
  }

  $(".testimoinal-text-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    autoplay: true,
    asNavFor: ".testimoinal-thumbnail-slider",
  });
  $(".testimoinal-thumbnail-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".testimoinal-text-slider",
    dots: false,
    prevArrow: '<div class="slick-arrow prev-arrow"></div>',
    nextArrow: '<div class="slick-arrow next-arrow"></div>',
    centerMode: false,
    autoplay: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
    ],
  });
});

let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
// console.log(items);
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
